/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const ExitIcon = ({
  className = "",
  fill = "#ffffff",
  width = "20",
  height = "20"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg" test-id="_EagSDNE">

      <path
        d="M28.36 50.36L34 56L54 36L34 16L28.36 21.64L38.68 32H0V40H38.68L28.36 50.36ZM64 0H8C3.56 0 0 3.6 0 8V24H8V8H64V64H8V48H0V64C0 68.4 3.56 72 8 72H64C68.4 72 72 68.4 72 64V8C72 3.6 68.4 0 64 0Z"
        fill={fill} test-id="a0A2LZ1Q" />

    </svg>);

};

export default ExitIcon;